import React, { Component } from 'react';
import firebase from '../helpers/firebase';
import { DashboardToolbar } from './DashboardToolbar';
import { Route, Switch } from 'react-router-dom';
import Home from './content/Home';
import Kitchen from './content/Kitchen';
import Calendar from "./content/Calendar"; 
import Insights from './content/Insights';
import Help from './content/Help'; 
import { LoadingScreen } from './LoadingScreen';
import styles from './Dashboard.module.css';
import { DashboardDrawer } from './DashboardDrawer';
import StudentFeedback from './content/StudentFeedback';

export default class Dashboard extends Component {
  static defaultProps = {
    user: null,
    signOut: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      campus: '',
      diningHall: '',
      diningHallPretty: '',
      diningHalls: {},
    };
  }

  async componentDidMount() {
    try {
      if (!this.props.user) {
        throw Error('User not signed in');
      }

      const userDocSnapshot = await firebase
        .firestore()
        .doc(`users/${this.props.user.uid}`)
        .get();
      const campuses = userDocSnapshot.get('campuses');
      if (!campuses) {
        throw Error('User has no permission to any campuses');
      }

      // TODO: Add campus switcher
      const campus = campuses[0];
      const hallsSnapshot = await firebase
        .firestore()
        .collection('campus')
        .doc(campus)
        .collection('halls')
        .get();

      let diningHalls = {};
      hallsSnapshot.docs.forEach((doc) => {
        diningHalls[doc.id] = doc.data();
      });
      this.setState({
        campus: campus,
        diningHall: hallsSnapshot.docs[0].id,
        diningHalls,
      });
    } catch (e) {
      console.error(e);
    }
  }

  updateCurrentDiningHall = (newHall, newHallPretty) => {
    this.setState({ diningHall: newHall, diningHallPretty: newHallPretty });
  };

  render() {
    if (this.state.loading && !this.state.user) {
      return <LoadingScreen />;
    }

    return (
      <div className={styles.dashboard}>
        <div className={styles.toolbar}>
          <DashboardToolbar
            signOut={this.props.signOut}
            updateCurrentDiningHall={this.updateCurrentDiningHall}
            diningHall={this.state.diningHall}
            diningHalls={this.state.diningHalls}
          />
        </div>

        <div className={styles.drawer}>
          <DashboardDrawer />
        </div>

        <div className={styles.content}>
          <Switch>
            <Route
              path="/dashboard"
              exact
              render={(props) => (
                <Home
                  user={this.props.user}
                  campus={this.state.campus}
                  diningHall={this.state.diningHall}
                  diningHalls={this.state.diningHalls}
                  {...props}
                />
              )}
            />
            <Route
              path="/dashboard/kitchen"
              exact
              render={props => (
                <Kitchen
                  user={this.props.user}
                  campus={this.state.campus}
                  diningHall={this.state.diningHall}
                  diningHalls={this.state.diningHalls}
                  {...props}
                />
              )}
            />
            <Route
              path="/dashboard/insights"
              exact
              render={(props) => (
                <Insights
                  user={this.props.user}
                  campus={this.state.campus}
                  diningHall={this.state.diningHall}
                  diningHalls={this.state.diningHalls}
                  {...props}
                />
              )}
            />
            <Route
              path="/dashboard/studentfeedback"
              render={(props) => (
                <StudentFeedback
                  {...props}
                  campus={this.state.campus}
                  diningHall={this.state.diningHall}
                />
              )}
            />
            <Route
              path="/dashboard/help"
              render={(props) => <Help {...props} user={this.props.user} />}
            />
            <Route
              path="/dashboard/calendar"
              render={(props) => (
                <Calendar
                  {...props}
                  campus={this.state.campus}
                  diningHall={this.state.diningHall}
                />
              )}
            />
          </Switch>
        </div>
      </div>
    );
  }
}
